import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../Baseurl";
const SellerOrderDetail = () => {
  const { orderid } = useParams();
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const sellerId = localStorage.getItem("seller_id");
        const response = await axios.get(
          `${baseurl}getOrderBySellerIdAndUniqueId/${sellerId}/${orderid}`
        );
        setOrderData(response.data);
      } catch (error) {
        console.error("Error fetching order:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderid]);

  if (loading) return <div className="p-4">Loading order details...</div>;
  if (!orderData) return <div className="p-4 text-red-500">No order found.</div>;

  const {
    unique_id,
    created_at,
    billing_name,
    billing_mobile,
    billing_email,
    billing_address,
    billing_state,
    billing_pincode,
    delivery_type,
    payment_method,
    cart_items,
    item_total,
    discount,
    total_price
  } = orderData;

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white shadow-xl rounded-xl">
      <h2 className="text-2xl font-bold mb-4">Order Details: #{unique_id}</h2>
      
      <div className="mb-6">
        <h3 className="text-lg font-semibold">Customer Info</h3>
        <p><strong>Name:</strong> {billing_name}</p>
        <p><strong>Mobile:</strong> {billing_mobile}</p>
        <p><strong>Email:</strong> {billing_email}</p>
        <p><strong>Address:</strong> {billing_address}, {billing_state}, {billing_pincode}</p>
      </div>

      <div className="mb-6">
        <h3 className="text-lg font-semibold">Order Info</h3>
        <p><strong>Order Date:</strong> {new Date(created_at).toLocaleString()}</p>
        <p><strong>Delivery Type:</strong> {delivery_type}</p>
        <p><strong>Payment Method:</strong> {payment_method}</p>
      </div>

      <div className="mb-6">
        <h3 className="text-lg font-semibold">Items</h3>
        {cart_items && cart_items.length > 0 ? (
          <ul className="space-y-4">
            {cart_items.map((item, idx) => (
              <li key={idx} className="border-b pb-2">
                <p><strong>Product:</strong> {item.product_name}</p>
                <p><strong>Qty:</strong> {item.qty}</p>
                <p><strong>Price:</strong> ₹{item.price}</p>
                <p><strong>Total:</strong> ₹{item.qty * item.price}</p>
              </li>
            ))}
          </ul>
        ) : (
          <p>No items found in this order.</p>
        )}
      </div>

      <div className="mt-6 border-t pt-4">
        <p><strong>Subtotal:</strong> ₹{item_total}</p>
        <p><strong>Discount:</strong> ₹{discount}</p>
        <p className="text-xl font-bold"><strong>Total:</strong> ₹{total_price}</p>
      </div>
    </div>
  );
};

export default SellerOrderDetail;
